import profileApiService from "../../services/api/ProfileApiService";
import profileService from "../../services/ProfileService";

export default {
  FETCH_MY_PROFILE({ commit }, success) {
    commit("FETCH_MY_PROFILE", "FETCHING");
    profileApiService
      .me()
      .then((myProfile) => {
        commit("FETCH_MY_PROFILE", myProfile);
        if (success) success(myProfile);
      })
      .catch((err) => {
        commit("FETCH_MY_PROFILE", err);
      });
  },
  FETCH_MANAGED_PROVIDERS({ commit }) {
    commit("FETCH_MANAGED_PROVIDERS", "FETCHING");
    profileApiService
      .managedProviders()
      .then((managedProviders) =>
        commit("FETCH_MANAGED_PROVIDERS", managedProviders)
      )
      .catch((err) => commit("FETCH_MANAGED_PROVIDERS", err));
  },
  SELECT_PROVIDER({ commit }, payload) {
    profileService.selectProvider(payload);
    commit("SELECT_PROVIDER", payload);
  },
};
